import React from 'react'
import { Outlet } from 'react-router-dom'

const TenyZarainaPage = () => {
  return (
    <Outlet />
  )
}

export default TenyZarainaPage